import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont, fundingType } from '../../theme/fundingTypography'
import {
  fundingModalPaper,
  fundingModalTitle,
  fundingModalTitleIcon,
} from '../../theme/fundingSharedStyles'

/** Used-in: Company | Funding request ID | Created by | Status */
export const useStyles = makeStyles()(() => ({
  paper: {
    ...fundingModalPaper,
    width: 960,
    maxHeight: 'min(560px, calc(100vh - 32px))',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
    flexShrink: 0,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
    flex: '1 1 auto',
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleIcon: {
    ...fundingModalTitleIcon,
  },
  title: {
    ...fundingModalTitle,
    whiteSpace: 'nowrap',
  },
  close: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    '& svg': { fontSize: 24, color: C.mutedText },
  },
  table: {
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  headerRow: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(0, 1.4fr) minmax(0, 1.6fr) minmax(0, 1.2fr) minmax(0, 0.8fr)',
    alignItems: 'center',
    width: '100%',
    flexShrink: 0,
  },
  headerCell: {
    boxSizing: 'border-box',
    padding: '0 16px 10px',
    ...fundingType.helper,
    color: C.mutedText,
    borderBottom: `1px solid ${C.divider}`,
    backgroundColor: C.cardBg,
    textAlign: 'left',
  },
  colCompany: {},
  colRequest: {},
  colCreatedBy: {},
  colStatus: {},
  row: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(0, 1.4fr) minmax(0, 1.6fr) minmax(0, 1.2fr) minmax(0, 0.8fr)',
    alignItems: 'center',
    width: '100%',
    minHeight: 44,
    flexShrink: 0,
  },
  rowAlt: {
    backgroundColor: C.activityNeutralIcon,
  },
  rowPlain: {
    backgroundColor: C.cardBg,
  },
  cellCompany: {
    boxSizing: 'border-box',
    minWidth: 0,
    padding: '12px 16px',
    ...fundingType.body,
    color: C.darkText,
  },
  companyCell: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
    maxWidth: '100%',
  },
  companyAvatar: {
    boxSizing: 'border-box',
    flexShrink: 0,
    width: 18,
    height: 18,
    borderRadius: 5,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: C.activityAvatar,
    color: C.cardBg,
    fontFamily: fundingFont,
    fontSize: 7,
    fontWeight: 700,
    lineHeight: '7px',
    letterSpacing: '-0.2px',
    boxShadow: '0px 1px 1px rgba(15, 23, 42, 0.14)',
  },
  companyName: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  cellRequest: {
    boxSizing: 'border-box',
    minWidth: 0,
    padding: '12px 16px',
    ...fundingType.body,
    color: C.darkText,
  },
  cellCreatedBy: {
    boxSizing: 'border-box',
    minWidth: 0,
    padding: '12px 16px',
    ...fundingType.body,
    color: C.darkText,
  },
  cellStatus: {
    boxSizing: 'border-box',
    minWidth: 0,
    padding: '12px 16px',
    ...fundingType.body,
    color: C.darkText,
    display: 'flex',
    alignItems: 'center',
  },
  requestLink: {
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    font: 'inherit',
    fontWeight: 500,
    color: C.linkBlue,
    textAlign: 'left',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline', textUnderlineOffset: 2 },
  },
  empty: {
    margin: 0,
    padding: '24px 16px',
    fontFamily: fundingFont,
    fontSize: 14,
    lineHeight: '20px',
    color: C.mutedText,
  },
}))
